import ChartCard from "./ChartCard";

export default ChartCard;
